import React from 'react';
import { useQuery } from '@apollo/client';
import { GET_ALL_TOTAL_STATS } from '../../../helpers/graphRequests';

export const GiveawayBanner = () => {
  const { data, error, loading, called } = useQuery(GET_ALL_TOTAL_STATS, {
    fetchPolicy: 'cache-and-network',
  });

  const totalUsers = data?.stats[0]?.totalUsers;
  const goal = 100000;

  const loaderWidth = (totalUsers / goal) * 100;

  return (
    <div className="flex items-center justify-between mt-[2rem] rounded-[3rem] h-[60rem] w-full overflow-hidden lg:h-[62rem]">
      <div className="flex flex-col justify-between relative w-full h-full giveawayBannerBg">
        <div className="flex flex-col items-start justify-between space-y-[2.4rem]  mt-[10.2rem] ml-[8rem] lg:ml-0 lg:mt-[4rem] lg:px-[1rem] lg:py-[1rem] lg:h-[20.5rem] lg:items-center lg:text-center">
          <span className="text-[8rem] giveawayBanner-title font-600 leading-[8.8rem] max-w-[68.8rem] lg:text-[4rem] lg:leading-[4.4rem] lg:max-w-[30rem]">
            СEX listing progress
          </span>
          {/* <span className="text-[1.6rem] font-500 leading-[2.4rem] text-white-500 max-w-[51rem] lg:text-[1.2rem] lg:leading-[1.68rem] lg:max-w-full">
            The more people on the platform, the higher your chance to vigate as soon as the stages end, random flatters
            will receive rewards
          </span> */}
          {/* <a href="/" target="blank" className="custom-transition hover:opacity-70">
            <span className="text-[1.6rem] font-500 leading-[2.4rem] text-[#985AFF]">Learn more...</span>
          </a> */}
        </div>
        <div className="relative flex flex-col h-[15rem] bg-[#811BFC] pl-[8rem] pt-[4.3rem] overflow-hidden lg:h-[8rem] lg:pl-auto lg:px-[2rem] lg:pt-0 lg:justify-center lg:z-[2]">
          <div className="flex items-center space-x-[1.2rem] font-600 z-[1] lg:space-x-[0.64rem]">
            <span className="text-[3.2rem] leading-[7.68px] text-white lg:text-[1.6rem] lg:leading-[3.84px]">
              {totalUsers?.toLocaleString('en-US')}
              <span className="text-white-500">/{goal?.toLocaleString('en-US')}</span>
            </span>
            <span className="text-[1.6rem] tracking-[-0.32px] font-500 text-white-500 lg:text-[1.1rem] lg:tracking-[-0.22px]">
              Users
            </span>
          </div>
          <div className="w-[61.8rem] h-[1.6rem] bg-white-200 rounded-full mt-[2.4rem] lg:w-full lg:mt-[1.2rem] lg:h-[0.8rem]">
            <div style={{ width: `${loaderWidth}%` }} className={`flex h-full bg-[#51F689] rounded-full`} />
          </div>
          <img
            className="absolute top-[-53rem] left-[-40rem] z-[0] pointer-events-none lg:top-[-35rem] lg:left-[-10rem]"
            src="/images/landing/giveawayBanner/footerShadow.webp"
          />
        </div>
        <img
          className="absolute right-0 bottom-0 h-[60rem] pointer-events-none z-[1] lg:hidden"
          src="/images/landing/giveawayBanner/phone.webp"
        />
        <img
          className="absolute right-0 bottom-0 h-[60rem] pointer-events-none z-[0] lg:hidden"
          src="/images/landing/giveawayBanner/pol.webp"
        />
        <img
          className="lg:hidden absolute right-0 bottom-0 h-[60rem] pointer-events-none z-[0] lg:h-[30rem] lg:left-1/2 lg:-translate-x-1/2"
          src="/images/landing/giveawayBanner/shadow.webp"
        />
        <img
          className="hidden lg:flex absolute left-1/2 -translate-x-1/2 h-[47rem] bottom-0 pointer-events-none z-[1]"
          src="/images/landing/giveawayBanner/phoneMob.webp"
        />
        <img
          className="hidden lg:flex absolute bottom-0 h-[40rem] pointer-events-none z-[0] left-1/2 -translate-x-1/2"
          src="/images/landing/giveawayBanner/shadowMob.webp"
        />
      </div>
    </div>
  );
};
